import { render, staticRenderFns } from "./com-steps.vue?vue&type=template&id=335aba10&scoped=true"
import script from "./com-steps.vue?vue&type=script&lang=js"
export * from "./com-steps.vue?vue&type=script&lang=js"
import style0 from "./com-steps.vue?vue&type=style&index=0&id=335aba10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335aba10",
  null
  
)

export default component.exports